import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import CopierCostWrapper from "@components/layouts/copierCostsWrapper";

import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";

export default function CopierCostHome(): ReactElement {
    return (
        <CopierCostWrapper>
            <TermsAndConditions
                category="Digital Copiers"
                domain="CopierCosts.com"
            />
        </CopierCostWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
